import React, { Component } from 'react';
import { createTagGroup, saveTagGroup, createTag, saveTag, getTags, deleteTagGroup, deleteTag } from '../../utility/tag';
import WaitForState from '../WaitForState';
import { addMessage } from '../../actions/messages';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';
import { hasOneOfPermissions } from '../../utility/account';
import './index.css';

/**
 * Component for showing tags
 *
 * @extends React.Component
 */
class Tags extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      tags: null,
      doneWorking: true,
      editTagAllowed: null,
      editGroupAllowed: null,
      disabled: false,
    }
  }

  /**
   * Handle when a tag group has been updated.
   */
  handleTagGroupUpdate = (tagGroupKey, field, e) => {
    if (!this.state.editGroupAllowed) {
      return;
    }

    var tagsC = this.state.tags;
    tagsC[tagGroupKey][field] = e.target.value;
    this.setState({tags: tagsC});

    // We don't want to trigger a request every time the user touches his
    // keyboard. Only trigger when he has not done so in half a second.
    if (this.saveTimeout === undefined) {
      this.saveTimeout = {};
    }
    if (this.saveTimeout[tagGroupKey + '-' + field] !== undefined) {
      window.clearTimeout(this.saveTimeout[tagGroupKey + '-' + field]);
    }
    this.saveTimeout[tagGroupKey + '-' + field] = window.setTimeout(() => {
      this.setState({doneWorking: false});
      if (this.state.tags[tagGroupKey].new) {
        this.setState({disabled: true});
        var newTagGroup = this.state.tags[tagGroupKey];
        delete newTagGroup.id;
        delete newTagGroup.new;

        createTagGroup(newTagGroup, this.props.token, this.props.history, (response) => {
          if (response.status !== 200) {
            this.props.dispatch(addMessage('Fejl under gemning af tag. Prøv venligst igen senere.', 'danger'));
          }
          this.setState({doneWorking: true, disabled: false});
          this.fetchTags();
        });
      } else {
        saveTagGroup(this.state.tags[tagGroupKey].id, field, this.state.tags[tagGroupKey][field], this.props.token, this.props.history, (response) => {
          if (response.status !== 200) {
            this.props.dispatch(addMessage('Fejl under gemning af tag. Prøv venligst igen senere.', 'danger'));
          }
          this.setState({doneWorking: true});
        });
      }
    }, 500);
  }

  /**
   * Handle when a tag has been updated.
   */
  handleTagUpdate = (tagGroupKey, tagKey, field, e) => {
    if (!this.state.editTagAllowed) {
      return;
    }

    var tagsC = this.state.tags;
    tagsC[tagGroupKey].tags[tagKey][field] = e.target.value;
    this.setState({tags: tagsC});

    // We don't want to trigger a request every time the user touches his
    // keyboard. Only trigger when he has not done so in half a second.
    if (this.saveTimeout === undefined) {
      this.saveTimeout = {};
    }
    if (this.saveTimeout[tagGroupKey + '-' + tagKey + '-' + field] !== undefined) {
      window.clearTimeout(this.saveTimeout[tagGroupKey + '-' + tagKey + '-' + field]);
    }
    this.saveTimeout[tagGroupKey + '-' + tagKey + '-' + field] = window.setTimeout(() => {
      this.setState({doneWorking: false});
      if (this.state.tags[tagGroupKey].tags[tagKey].new) {
        this.setState({disabled: true});
        var newTag = this.state.tags[tagGroupKey].tags[tagKey];
        delete newTag.id;
        delete newTag.new;

        createTag(this.state.tags[tagGroupKey].id, newTag, this.props.token, this.props.history, (response) => {
          if (response.status !== 200) {
            this.props.dispatch(addMessage('Fejl under gemning af tag. Prøv venligst igen senere.', 'danger'));
          }
          this.setState({doneWorking: true, disabled: false});
          this.fetchTags();
        });
      } else {
        saveTag(this.state.tags[tagGroupKey].id, this.state.tags[tagGroupKey].tags[tagKey].id, field, this.state.tags[tagGroupKey].tags[tagKey][field], this.props.token, this.props.history, (response) => {
          if (response.status !== 200) {
            this.props.dispatch(addMessage('Fejl under gemning af tag. Prøv venligst igen senere.', 'danger'));
          }
          this.setState({doneWorking: true});
        });
      }
    }, 500);
  }

  /**
   * Fetch permission to edit tags and groups.
   */
  fetchEditAllowedPermission = () => {
    hasOneOfPermissions(this.props.user.id, ["modify any tag", "modify any tag group"], this.props.token, this.props.history, (a, allowed) => {
      this.setState({editTagAllowed: allowed['modify any tag'], editGroupAllowed: allowed['modify any tag group']});
    });
  }

  /**
   * Fetch tags.
   */
  fetchTags = () => {
    getTags(this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af tags. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        this.setState({tags: data});
      });
    });
  }

  /**
   * Handle clicking the add tag group button.
   */
  handleAddTagGroup = () => {
    var tagsC = this.state.tags;
    var newId = 'new-' + Date.now();
    tagsC.push({
      name: '',
      id: newId,
      new: true,
      tags: [],
    });

    this.setState({tags: tagsC});
  }

  /**
   * Handle clicking the add tag.
   */
  handleAddTag = (tagGroupKey) => {
    var tagsC = this.state.tags;
    var newId = 'new-' + Date.now();
    tagsC[tagGroupKey].tags.push({
      name: '',
      id: newId,
      new: true,
    });

    this.setState({tags: tagsC});
  }

  /**
   * Delete tag group.
   */
  handleDeleteTagGroup = (tagGroupKey) => {
    if (window.confirm('Er du sikker på at du vil slette tag-gruppe?')) {
      this.setState({doneWorking: false});

      deleteTagGroup(this.state.tags[tagGroupKey].id, this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under sletning af tag-gruppe. Prøv venligst igen senere.', 'danger'));
        }
        this.setState({doneWorking: true});
        this.fetchTags();
      });
    }
  }

  /**
   * Delete tag.
   */
  handleDeleteTag = (tagGroupKey, tagKey) => {
    if (window.confirm('Er du sikker på at du vil slette tag?')) {
      this.setState({doneWorking: false});

      deleteTag(this.state.tags[tagGroupKey].id, this.state.tags[tagGroupKey].tags[tagKey].id, this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under sletning af tag. Prøv venligst igen senere.', 'danger'));
        }
        this.setState({doneWorking: true});
        this.fetchTags();
      });
    }
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchTags();
    this.fetchEditAllowedPermission();
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="tab-pane fade show active" id="tags" role="tabpanel" aria-labelledby="tags">
        <div className="widget">
          <WaitForState keys={['doneWorking']} state={this.state} />
          <h3 className="section-heading">Tags</h3>
          <WaitForState state={this.state} keys={['tags']}>
            {this.state.tags && this.state.tags.map((tagGroup, tagGroupKey) => {
              return (
              <div className="form-group tag-group" key={tagGroup.id}>
                <input type="text" className="form-control" placeholder="Navn" onChange={(e) => {this.handleTagGroupUpdate(tagGroupKey, 'name', e)}} value={tagGroup.name} disabled={this.state.editGroupAllowed ? (this.state.disabled ? 'disabled' : '') : 'disabled'} />
                { !tagGroup.new && <button type="button" className="close remove-button" aria-label="Delete" onClick={(e) => {this.handleDeleteTagGroup(tagGroupKey, e)}}>
                  <span aria-hidden="true">&times;</span>
                </button>}
                {this.state.tags[tagGroupKey].tags.map((tag, tagKey) => {
                  return (
                  <div className="form-group tag" key={tag.id}>
                    <input type="text" className="form-control" placeholder="Navn" onChange={(e) => {this.handleTagUpdate(tagGroupKey, tagKey, 'name', e)}} value={tag.name} disabled={this.state.editTagAllowed ? (this.state.disabled ? 'disabled' : '') : 'disabled'} />
                    { !tag.new && <button type="button" className="close remove-button" aria-label="Delete" onClick={(e) => {this.handleDeleteTag(tagGroupKey, tagKey, e)}}>
                      <span aria-hidden="true">&times;</span>
                    </button>}
                  </div>
                )})}
                <button className="btn btn-primary" onClick={(e) => {this.handleAddTag(tagGroupKey, e);}}>Tilføj tag</button>
              </div>
            )})}
          </WaitForState>
          <button className="btn btn-primary" onClick={this.handleAddTagGroup}>Tilføj tag-gruppe</button>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(Tags)));



// WEBPACK FOOTER //
// ./src/components/Tags/index.js